import React from "react";
import "./App.css";

import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import WordHunt from "./pages/WordHunt";
import Landing from "./pages/Landing";
import WordBites from "./pages/WordBites";
import Anagrams from "./pages/Anagrams";

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/wordhunt" element={<WordHunt />} />
            <Route path="/wordbites" element={<WordBites />} />
            <Route path="/anagrams" element={<Anagrams />} />
            <Route path="" exact element={<Landing />} />
        </Routes>
    </Router>
  );
}

export default App;
